@if (isLoading$ | async) {
<div class="global-loading-bar">
    <div class="global-loading-bar__track"></div>
    <div class="global-loading-bar__indicator"></div>
</div>
}
<router-outlet></router-outlet>
